//import * as React from 'react';
import {Card as MuiCard} from '@material-ui/core';
import {withStyles} from '@material-ui/core/styles';

const CardComp = withStyles(theme => ({
    root: {
        [theme.breakpoints.up('sm')]: {
            order: -1,
            // width: '11em',
            width: '13em',
            // minWidth: '10em',
            minWidth: '12em',
            marginRight: '1em',
        },
        [theme.breakpoints.down('sm')]: {
            order: -1,
            width: 200,
            // marginRight: '1em',
            // marginTop: '3em',
            display: 'none',
            position: 'fixed',
            top: 48,
            right: 8,
            zIndex: 4,
            backgroundColor: '#fefefefe',
        },
    },
}))(MuiCard);

export default CardComp;
